import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BusinessActions, BusinessState } from '@state/business';
import { Observable } from 'rxjs';
import { allowedIdleTimeoutOptions } from './security.model';

@Component({
	selector: 'app-security',
	templateUrl: './security.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SecurityComponent {
	@Select(BusinessState.getIdleTimeoutMinutes)
	idleTimeoutMinutes$: Observable<number>;
	@Select(BusinessState.isIdleTimeoutDisabled)
	isIdleTimeoutDisabled$: Observable<boolean>;

	public allowedIdleTimeoutOptions = structuredClone(allowedIdleTimeoutOptions);

	constructor(private store: Store) {}

	onIdleTimeoutDurationChange(idleTimeoutSelection: string) {
		this.store.dispatch(
			new BusinessActions.UpdateSecurity({
				idleTimeoutMinutes: Number(idleTimeoutSelection),
			}),
		);
	}
}
